import { ReactNode } from 'react';

export function extractTextFromReactNode(node: ReactNode): string {
    if (typeof node === 'string' || typeof node === 'number') return node.toString();
    if (Array.isArray(node)) return node.map(extractTextFromReactNode).join(' ');
    if (typeof node === 'object' && node !== null && 'props' in node) {
        return extractTextFromReactNode((node as any).props.children);
    }
    return '';
}